// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductCardNotification.module.scss  */
.ProductCardNotification-module-Text_3Yz {
  font-family: var(--control-font-family);
  font-size: var(--product-card-font-size-notification);
  font-weight: 600;
  line-height: var(--product-card-line-height-notification); }

.ProductCardNotification-module-Icon_2po {
  width: 14px;
  height: 11px;
  margin-right: 11px; }

.ProductCardNotification-module-SubscribeButton_1oL {
  width: 126px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 30px;
  background-color: var(--product-card-color-notification);
  transition: all 0.2s linear; }

.ProductCardNotification-module-Root_2O0.ProductCardNotification-module-checked_364 .ProductCardNotification-module-SubscribeButton_1oL {
  border-color: var(--product-card-color-notification);
  background-color: transparent; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ProductCard/Notification/ProductCardNotification.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,uCAAuC;EACvC,qDAAqD;EACrD,gBAAgB;EAChB,yDAAyD,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,wDAAwD;EACxD,2BAA2B,EAAE;;AAE/B;EACE,oDAAoD;EACpD,6BAA6B,EAAE","sourcesContent":["/*  imported from ProductCardNotification.module.scss  */\n.ProductCardNotification-module-Text_3Yz {\n  font-family: var(--control-font-family);\n  font-size: var(--product-card-font-size-notification);\n  font-weight: 600;\n  line-height: var(--product-card-line-height-notification); }\n\n.ProductCardNotification-module-Icon_2po {\n  width: 14px;\n  height: 11px;\n  margin-right: 11px; }\n\n.ProductCardNotification-module-SubscribeButton_1oL {\n  width: 126px;\n  height: 32px;\n  border: 1px solid transparent;\n  border-radius: 30px;\n  background-color: var(--product-card-color-notification);\n  transition: all 0.2s linear; }\n\n.ProductCardNotification-module-Root_2O0.ProductCardNotification-module-checked_364 .ProductCardNotification-module-SubscribeButton_1oL {\n  border-color: var(--product-card-color-notification);\n  background-color: transparent; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
